import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import './AppHeader.css';
import {AppstoreOutlined, DownOutlined, HomeOutlined, UserOutlined} from '@ant-design/icons';
import {Divider, Dropdown, Layout, Menu, Space, Typography} from 'antd';
import FinancialSealApps from "../page/token/apps/FinancialSealApps";
import {language} from "../util/language";

const Header = Layout.Header;

class AppHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 'mail',
        };
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.hasRole = this.hasRole.bind(this);
    }

    handleMenuClick({key}) {
        if (key === "/logout") {
            this.props.onLogout();
        }
    }

    handleClick(e) {
        this.setState({current: e.key},()=>this.props.history.push(e.key));
    }

    hasRole(roleName){
        const hasRoleToken = this.props.currentUser.authorities.some(authority => authority.authority === roleName);
        return hasRoleToken;
    }

    render() {
        console.log(this, "this")
        let menuItems;
        if (this.props.currentUser) {
            menuItems = [
                this.hasRole('ROLE_TENANT') && ["/tenant-list","/apartment-list"].includes(this.props.location.pathname) && (<Menu.Item key="/lang" style={{marginLeft: "auto"}}>
                    <LanguageMenu
                        currentUser={this.props.currentUser}
                        language={this.props.language}
                        onChangeLanguage={this.props.onChangeLanguage}/>
                </Menu.Item>),
                <Menu.Item key="/profile" className="profile-menu">
                    <ProfileDropdownMenu
                        currentUser={this.props.currentUser}
                        handleMenuClick={this.handleMenuClick}/>
                </Menu.Item>
            ];
        } else {
            menuItems = [
                <Menu.Item key="/login">
                    <Link to="/login">Giriş</Link>
                </Menu.Item>
            ];
        }

        return (
            <Header className="app-header">
                <div className="container">
                    <div className="app-title">
                        {this.props.currentUser &&
                        <Menu onClick={this.handleClick}
                              className="app-menu"
                              selectedKeys={[this.props.location.pathname]}
                              mode="horizontal">
                            {!this.hasRole("ROLE_TENANT") &&
                            <Menu.Item key="/">
                                <HomeOutlined style={{ color: 'volcano' }} className="nav-icon"/>
                            </Menu.Item>
                            }
                            {this.hasRole("ROLE_PAY") && (this.props.location.pathname === "/home" || this.props.location.pathname === "/my-payment") &&
                                <Menu.Item key="/home">
                                    <AppstoreOutlined style={{color: '#eb2f96'}} className="nav-icon"/>
                                    İstatistikler
                                </Menu.Item>
                            }
                            {this.hasRole("ROLE_PAY") && (this.props.location.pathname === "/home" || this.props.location.pathname === "/my-payment") &&
                                    <Menu.Item key="/my-payment">
                                        <AppstoreOutlined style={{color: '#08c'}} className="nav-icon"/>
                                        Ödemeler
                                    </Menu.Item>
                            }
                            {this.hasRole('ROLE_TOKEN') && (this.props.location.pathname === "/financial-seal-home" || this.props.location.pathname === "/financial-seal-apps") &&
                                <Menu.Item key="/financial-seal-home">
                                    <AppstoreOutlined style={{ color: '#eb2f96' }}  className="nav-icon" />
                                    İstatistikler
                                </Menu.Item>
                            }
                            {this.hasRole('ROLE_TOKEN') && (this.props.location.pathname === "/financial-seal-home" || this.props.location.pathname === "/financial-seal-apps") &&
                                <Menu.Item key="/financial-seal-apps">
                                    <AppstoreOutlined style={{ color: '#08c' }} className="nav-icon"/>
                                   Başvurular
                                </Menu.Item>
                            }
                            {this.hasRole('ROLE_TENANT') && ["/tenant-list","/apartment-list"].includes(this.props.location.pathname) &&
                                <Menu.Item key="/apartment-list">
                                    <AppstoreOutlined style={{ color: '#cca300' }} className="nav-icon"/>
                                    {language(this.props.language, 'apartment_list')}
                                </Menu.Item>
                            }
                            {this.hasRole('ROLE_TENANT') && ["/tenant-list","/apartment-list"].includes(this.props.location.pathname) &&
                                <Menu.Item key="/tenant-list">
                                    <AppstoreOutlined style={{ color: '#08c' }} className="nav-icon"/>
                                    {language(this.props.language, 'tenant_list')}
                                </Menu.Item>
                            }
                        </Menu>
                        }
                    </div>
                    <Menu
                        className="app-menu"
                        mode="horizontal"
                        selectedKeys={[this.props.location.pathname]}
                        style={{lineHeight: '64px'}}>
                        {menuItems}
                    </Menu>
                </div>
            </Header>
        );
    }
}

function ProfileDropdownMenu(props) {
    const dropdownMenu = (
        <Menu onClick={props.handleMenuClick} className="profile-dropdown-menu">
            <Menu.Item key="/user-info" className="dropdown-item" disabled>
                <div className="user-full-name-info">
                    {props.currentUser.name}
                </div>
                <div className="username-info">
                    @{props.currentUser.username}
                </div>
            </Menu.Item>
            <Menu.Divider/>
            {!(window.location.href.indexOf('aljabe') > -1) &&
            <Menu.Item key="profile" className="dropdown-item">
                <Link to={`/auth/${props.currentUser.username}`}>Profile</Link>
            </Menu.Item>
            }
            <Menu.Item key="/logout" className="dropdown-item">
                {(window.location.href.indexOf('aljabe') > -1) ? language("ar",'exit') : "Çıkış"}
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown
            overlay={dropdownMenu}
            trigger={['click']}
            getPopupContainer={() => document.getElementsByClassName('profile-menu')[0]}>
            <a className="ant-dropdown-link">
                <UserOutlined className="nav-icon" style={{marginRight: 0}}/> <DownOutlined/>
            </a>
        </Dropdown>
    );
}


function LanguageMenu(props) {
    const langs = [
        {code: "en", label: 'English'},
        {code: "tr", label: 'Türkçe' },
        {code: "ar", label: 'العربية'}];

    return (<Space size={4} align={"center"}>
        {langs.map(({code, label}, idx) => (
            <span key={code}>
           <Typography.Text
               key={code}
               onClick={() => props.onChangeLanguage(code)}
               style={{fontWeight:  props.language === code ? 600 : 400}}
               /*onClick={() => props.handleMenuClick({key: `/lang/${lang}`})}*/

           >{label}</Typography.Text>
                {idx < langs.length - 1 && <Divider type={"vertical"}/>}
    </span>
        ))}
    </Space>)
}


export default withRouter(AppHeader);


// WEBPACK FOOTER //
// ./src/common/AppHeader.js